import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import ChangePhoneService from "./ChangePhoneService.jsx";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import FormControl from "react-bootstrap/FormControl";

import Result from "../../../components/result/Result.jsx";
import Spinner from "react-bootstrap/Spinner";
import InputGroup from "react-bootstrap/InputGroup";
import { utils } from "../../../utils/Utils.jsx";
import ErrorMessageComponent from "../../../components/errorMessageComponent/ErrorMessageComponent.jsx";

const ChangePhone = (props) => {
  const [isMobileWidth, setIsMobileWidth] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [newPhoneNumber, setNewPhoneNumber] = useState("");
  const [stage, setStage] = useState(1);
  const [invalidCountryCode, setInvalidCountryCode] = useState(false);
  const [invalidNewPhoneNumber, setInvalidNewPhoneNumber] = useState(false);
  const [loadingSent, setLoadingSent] = useState(false);
  const [errorMessageType, setErrorMessageType] = useState("");

  const service = new ChangePhoneService();

  useEffect(() => {
    if (
      props.location &&
      props.location.megastate &&
      props.location.megastate.phone
    ) {
    } else {
      utils.goToURL(props, "/dashboard/settings");
    }

    const setState = (updates) => {
      if (updates.isMobileWidth !== undefined)
        setIsMobileWidth(updates.isMobileWidth);
    };

    utils.checkWindowWidth(
      setState,
      props.changeGoBackNavBar,
      true,
      "/dashboard/settings",
    );

    const handleResize = () => {
      utils.checkWindowWidth(
        setState,
        props.changeGoBackNavBar,
        true,
        "/dashboard/settings",
      );
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const changePhone = () => {
    setErrorMessageType("");

    if (countryCode != "" && newPhoneNumber != "") {
      setInvalidCountryCode(false);
      setInvalidNewPhoneNumber(false);
      setLoadingSent(true);

      const state = { countryCode, newPhoneNumber };
      const setState = (updates) => {
        if (updates.loadingSent !== undefined)
          setLoadingSent(updates.loadingSent);
        if (updates.stage !== undefined) setStage(updates.stage);
        if (updates.invalidCountryCode !== undefined)
          setInvalidCountryCode(updates.invalidCountryCode);
        if (updates.invalidNewPhoneNumber !== undefined)
          setInvalidNewPhoneNumber(updates.invalidNewPhoneNumber);
      };

      service.changePhone(
        props.token,
        state,
        setState,
        setMessages,
        props.getClientConfig,
      );
    } else {
      setMessages("one-or-more-required-fields-are-missing");
      setInvalidCountryCode(countryCode === "");
      setInvalidNewPhoneNumber(newPhoneNumber === "");
    }
  };

  const setMessages = (type) => {
    setErrorMessageType(type);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "countryCode") setCountryCode(value);
    if (name === "newPhoneNumber") setNewPhoneNumber(value);
  };

  return (
    <React.Fragment>
      <div class="verify-info-container page-container">
        <div class="middle-container container-padding">
          {stage === 1 ? (
            <div class="form-container">
              <div class="main-title">
                {props.localizedText["change-phone-number"]}
              </div>

              <div class="fade-in-up">
                <div class="message">
                  {
                    props.localizedText[
                      "you-will-need-to-verify-your-phone-number-after-making-any-changes-to-it"
                    ]
                  }
                </div>
                <div class="div-parent-flex-column">
                  <Form.Group className="mb-3">
                    <Form.Label className="input-label-outside-div">
                      {props.localizedText["phone-number"]}
                    </Form.Label>
                    <FormControl
                      type="text"
                      name="phone"
                      value={
                        props.location &&
                        props.location.megastate &&
                        props.location.megastate.phone
                          ? props.location.megastate.phone
                          : ""
                      }
                      disabled
                      className="input-field"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label
                      className={
                        isMobileWidth
                          ? "input-label-outside-div"
                          : "input-label-inside-div"
                      }
                    >
                      {props.localizedText["new-phone-number"]}
                    </Form.Label>
                    <InputGroup className="mb-3 input-field">
                      <Form.Select
                        variant="outline-secondary"
                        onChange={handleChange}
                        name="countryCode"
                        isInvalid={invalidCountryCode}
                        style={{
                          width: "5rem",
                          flex: "0 1 auto",
                          textAlign: "center",
                        }}
                        disabled={loadingSent}
                      >
                        <option></option>
                        {props.globalProps.areaCodes.map((areaCode) => (
                          <option
                            key={areaCode.phone_area_code}
                            value={areaCode.phone_area_code}
                          >
                            {areaCode.phone_area_code}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control
                        type="tel"
                        name="newPhoneNumber"
                        value={newPhoneNumber}
                        onChange={handleChange}
                        isInvalid={invalidNewPhoneNumber}
                        className="input-field"
                        disabled={loadingSent}
                      />
                    </InputGroup>
                  </Form.Group>
                  <ErrorMessageComponent
                    errorMessage={props.localizedText[errorMessageType]}
                  ></ErrorMessageComponent>
                  <div class="buttons-div">
                    <Button
                      className="primary-button outside-primary-button"
                      onClick={changePhone}
                      disabled={loadingSent}
                    >
                      {loadingSent ? (
                        <Spinner className="loader-send-outside-div-button"></Spinner>
                      ) : null}
                      {props.localizedText["change"]}
                    </Button>

                    <Button
                      className="secondary-button outside-secondary-button"
                      onClick={() =>
                        utils.goToURL(props, "/dashboard/settings")
                      }
                    >
                      {props.localizedText["cancel"]}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {stage === 2 ? (
            <Result
              success={true}
              secondButton={true}
              title={props.localizedText["success"]}
              message={
                props.localizedText[
                  "your-phone-number-has-been-successfully-changed"
                ]
              }
              primaryButtonText={props.localizedText["verify-phone"]}
              primaryButtonFunction={() =>
                utils.goToURL(props, "/dashboard/settings/verify-phone")
              }
              secondaryButtonText={props.localizedText["settings"]}
              secondaryButtonFunction={() =>
                utils.goToURL(props, "/dashboard/settings")
              }
            ></Result>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ChangePhone);
